<template>
  <div>
    <div v-if="panel">
      <h4>Details for {{panel.title}}</h4>
      <b-form>
        <b-form-group v-for="(field, i) in fields" :key="'field-'+i">
          <label class="field-label" for="field">{{field[1]}}</label>
          <div class="field-value">{{panel[field[0]] || '---'}}</div>
          <hr />
        </b-form-group>
        <b-form-group>
          <label>Designations</label>
          <table class="designations" width=100%>
            <tr>
              <td>Critical Power</td>
              <td>
                <i class="fa" :class="!!panel['criticalPower'] ? 'fa-check' : 'fa-times'"></i>
              </td>
            </tr>
            <tr>
              <td>UPS</td>
              <td>
                <i class="fa" :class="!!panel['ups'] ? 'fa-check' : 'fa-times'"></i>
              </td>
            </tr>
            <tr>
              <td>Generator</td>
              <td>
                <i class="fa" :class="!!panel['generator'] ? 'fa-check' : 'fa-times'"></i>
              </td>
            </tr>
            <tr>
              <td>Other</td>
              <td>
                <span v-if="panel['otherDesignation']">{{panel['otherDesignation']}}</span>
                <i v-else class="fa fa-times"></i>
              </td>
            </tr>
          </table>
          <hr>
        </b-form-group>
        <BFR :node="panel.node"/>
        <!-- <b-form-group>
          <label for="title">Title</label>
          <b-form-input id="title" v-model="panel.title">{{panel.title}}</b-form-input>
        </b-form-group>
        <b-form-group>
          <label for="busRating">Bus Rating (Amps)</label>
          <b-form-input id="busRating" v-model="panel.busRating">{{panel.busRating}}</b-form-input>
        </b-form-group>
        <b-form-group>
          <label for="voltageRating">Voltage Rating</label>
          <b-form-input id="voltageRating" v-model="panel.voltageRating">{{panel.voltageRating}}</b-form-input>
        </b-form-group>
        <b-form-group>
          <label for="panelType">Panel Type: As Shown on Mfg Nameplate</label>
          <b-form-input id="panelType" v-model="panel.panelType">{{panel.panelType}}</b-form-input>
        </b-form-group>
        <b-form-group>
          <label for="mountingType">Mounting Type</label>
          <b-form-input id="mountingType" v-model="panel.mountingType">{{panel.mountingType}}</b-form-input>
        </b-form-group>
        <b-form-group>
          <label for="manufacturer">Manufacturer</label>
          <b-form-input id="manufacturer" v-model="panel.manufacturer">{{panel.manufacturer}}</b-form-input>
        </b-form-group>
        <b-form-group>
          <label for="breakerType">MCB or MLO</label>
          <b-form-input id="breakerType" v-model="panel.breakerType">{{panel.breakerType}}</b-form-input>
        </b-form-group>
        <b-form-group>
          <label for="mainBreakerRating">Main Breaker Amp Rating</label>
          <b-form-input
            id="mainBreakerRating"
            v-model="panel.mainBreakerRating"
          >{{panel.mainBreakerRating}}</b-form-input>
        </b-form-group>-->
      </b-form>
    </div>
  </div>
</template>

<script>
import BFR from './BFR.vue';

export default {
  name: "panel",
  components: {
    BFR
  },
  props: {
    panel: {}
  },
  data: () => ({
    loading: false,
    errors: [],
    filter: "",
    fields: [
      ["title", "Title"],
      ["voltageRating", "Voltage Rating"],
      ["busRating", "Bus Rating (Amps)"],
      ["panelType", "Panel Type: As Shown on Mfg Nameplate"],
      ["mountingType", "Mounting Type"],
      ["manufacturer", "Manufacturer"],
      ["breakerType", "MCB or MLO"],
      ["mainBreakerRating", "Main Breaker Amp Rating"]
    ]
  }),
  methods: {}
};
</script>

<style lang="scss" scoped>
.designations {
  tr {
    border-bottom: 1px solid gray;
  }
}
</style>
